import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m15 5-3-3-3 3M15 19l-3 3-3-3M12 2v8M12 14v8",
      class: "st0"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "2",
      class: "st0"
    }, null, -1)
  ]))]))
}
export default { render: render }